import router from '@/router'
import { getuser, login, logout } from 'api/user'

import { getUserInfo } from '@/api/new_api'
import { batchUpdateState } from 'utils'
import { getCookie, removeCookie, setCookie } from 'utils/cookie'
const tokenKey = process.env.VUE_APP_TOKEN

const updateUserInfo = (commit, data) => {
  commit('batchUpdateState', data)
}

const state = {
  user: null
}

const mutations = {
  batchUpdateState: (state, payload) => {
    batchUpdateState(state, payload)
  }
}

const actions = {
  async login({ commit }, userInfo) {
    const result = await login(userInfo)
    const { token, user } = result.data
    updateUserInfo(commit, { token, user })
    return result
  },
  // 获取用户资料
  getuser({ commit }) {
    return new Promise((resolve, reject) => {
      getUserInfo()
        .then((result) => {
          console.log('获取用户信息成功', result)
          updateUserInfo(commit, { user: result.data })
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // user logout
  logout({ dispatch }) {
    return new Promise((resolve, reject) => {
      logout()
        .then((result) => {
          dispatch('resetUserInfo')
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // remove token
  resetUserInfo({ commit }) {
    return new Promise((resolve) => {
      commit('batchUpdateState', { user: null })
      removeCookie('token')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
